(function () {
  function qs(s, r){ return (r||document).querySelector(s); }
  function qsa(s, r){ return Array.from((r||document).querySelectorAll(s)); }

  function openModal() {
    var m = qs("#zb-advent-modal");
    if (!m) return;
    m.classList.add("is-open");
    m.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
  }

  function closeModal() {
    var m = qs("#zb-advent-modal");
    if (!m) return;
    m.classList.remove("is-open");
    m.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
  }

  function dayIndexFromStart(startMonth, startDay) {
    var now = new Date();
    var start = new Date(now.getFullYear(), startMonth - 1, startDay);
    return Math.floor((now - start) / 86400000) + 1; // 1..N
  }

  function init() {
    var section = qs(".zb-advent");
    if (!section) return;

    var startMonth = parseInt(section.dataset.startMonth || "12", 10);
    var startDay = parseInt(section.dataset.startDay || "15", 10);
    var days = parseInt(section.dataset.days || "14", 10);

    var todayIndex = dayIndexFromStart(startMonth, startDay);

    qsa(".zb-advent__cell", section).forEach(function (btn) {
      var day = parseInt(btn.dataset.day, 10);

      if (todayIndex < 1 || todayIndex > days) btn.classList.add("is-locked");
      else {
        if (todayIndex < day) btn.classList.add("is-locked");
        if (todayIndex === day) btn.classList.add("is-today");
      }

      btn.addEventListener("click", function () {
        if (btn.classList.contains("is-locked")) return;

        qs("#zb-advent-modal-title").textContent = btn.dataset.title || "Today's Surprise";
        qs(".zb-advent-modal__desc").textContent = btn.dataset.desc || "";

        var codeWrap = qs(".zb-advent-modal__codeWrap");
        var codeBtn = qs("#zb-advent-copy");
        var hint = qs("#zb-advent-hint");
        var code = (btn.dataset.code || "").trim();

        if (code) {
          codeWrap.hidden = false;
          codeBtn.textContent = code;
          hint.textContent = "Tap to copy";
        } else {
          codeWrap.hidden = true;
        }

        openModal();
      });
    });

    qsa("[data-zb-close]").forEach(function (el) {
      el.addEventListener("click", closeModal);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeModal();
    });

    var copyBtn = qs("#zb-advent-copy");
    if (copyBtn) {
      copyBtn.addEventListener("click", async function () {
        try {
          await navigator.clipboard.writeText(copyBtn.textContent);
          qs("#zb-advent-hint").textContent = "Copied ✅";
        } catch (e) {
          qs("#zb-advent-hint").textContent = "Copy blocked by browser";
        }
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

